import {
    StepperDropdownContainer,
    StepperDropdownContent,
    StepperDropdownHeader,
    StepperDropdownHeaderIcon,
    StepperDropdownHeaderTitle
} from '../../dropdown/StepperDropdown'
import { StepCompletedSvg } from '../../../../../CommonComponents/svgs/Svgs'
import { FC, useMemo } from 'react'
import { StepperProps } from '../../../utils/stepper-types'
import useForm from '../../../hooks/useForm'
import { clampToDecimalsOnChange, onKeyDown, showToastMessage, validateInputRange } from '../../../../../../utils/commonFunctions'

const InitialAltitude: FC<StepperProps> = ({ title, hideComponent, open, disabled, stepCompleted, onToggle }) => {

    const { formData, setFormData } = useForm()
    const orientation = useMemo(() => formData.initial_altitude.orientation, [formData.initial_altitude.orientation])
    const angularRate = useMemo(() => formData.initial_altitude.angularRate, [formData.initial_altitude.angularRate])
    const { roll, pitch, yaw } = useMemo(() => orientation, [orientation])
    const { omegaX, omegaY, omegaZ } = useMemo(() => angularRate, [angularRate])

    const onInputChange = (altitudeType: 'orientation' | 'angularRate', key: string, value: string) => {
        const name = altitudeType === 'orientation' ? 'Orientation' : 'Angular rate'
        if (clampToDecimalsOnChange(value, 4, showToastMessage)) return
        const maxValue = altitudeType === 'angularRate' ? 500 : 360
        const validation = validateInputRange(key, value, 0, maxValue, 8, '')
        if (validation.success) {
            setFormData({
                ...formData,
                initial_altitude: {
                    ...formData.initial_altitude,
                    [altitudeType]: {
                        ...formData.initial_altitude[altitudeType],
                        [key]: validation.value
                    }
                }
            })
        } else {
            if (altitudeType === 'orientation') {
                showToastMessage('info', name + ' must be between 0° & 360° ')
            } else if (altitudeType === 'angularRate') {
                showToastMessage('info', name + ' must be between 0°/sec & 500°/sec ')
            }
        }
    }

    if (hideComponent) return null
    return (
        <StepperDropdownContainer
            open={open}
            disabled={disabled}
        >
            <StepperDropdownHeader
                title={title}
                onToggle={onToggle}
            >
                <StepperDropdownHeaderTitle>
                    {title}
                </StepperDropdownHeaderTitle>
                <StepperDropdownHeaderIcon show={stepCompleted}>
                    <StepCompletedSvg />
                </StepperDropdownHeaderIcon>
            </StepperDropdownHeader>
            <StepperDropdownContent>
                <div className='form__input__container'>
                    <span className='form__input__label'>Orientation</span>
                    <div className='d-flex align-items-center gap-2'>
                        <div className='form__field__container'>
                            <input type='number'
                                value={roll}
                                className='form__input small'
                                onKeyDown={onKeyDown}
                                onChange={(e) => onInputChange('orientation', 'roll', e.target.value)}
                            />
                        </div>
                        <div className='form__field__container'>
                            <input type='number'
                                value={pitch}
                                className='form__input small'
                                onKeyDown={onKeyDown}
                                onChange={(e) => onInputChange('orientation', 'pitch', e.target.value)}
                            />
                        </div>
                        <div className='form__field__container'>
                            <input type='number'
                                value={yaw}
                                className='form__input small'
                                onKeyDown={onKeyDown}
                                onChange={(e) => onInputChange('orientation', 'yaw', e.target.value)}
                            />
                            <span className='parameter__section'>°</span>
                        </div>
                    </div>

                </div>
                <div className='form__input__container'>
                    <span className='form__input__label'>Angular Rate</span>
                    <div className='d-flex align-items-center gap-2'>
                        <div className='form__field__container'>
                            <input type='number'
                                value={omegaX}
                                className='form__input small'
                                onKeyDown={onKeyDown}
                                onChange={(e) => onInputChange('angularRate', 'omegaX', e.target.value)}
                            />
                        </div>
                        <div className='form__field__container'>
                            <input type='number'
                                value={omegaY}
                                className='form__input small'
                                onKeyDown={onKeyDown}
                                onChange={(e) => onInputChange('angularRate', 'omegaY', e.target.value)}
                            />
                        </div>
                        <div className='form__field__container'>
                            <input type='number'
                                value={omegaZ}
                                className='form__input small'
                                onKeyDown={onKeyDown}
                                onChange={(e) => onInputChange('angularRate', 'omegaZ', e.target.value)}
                            />
                            <span className='parameter__section'>°/s</span>
                        </div>
                    </div>

                </div>
            </StepperDropdownContent>
        </StepperDropdownContainer>
    )
}
export default InitialAltitude